import dynamic from "next/dynamic";
const DynamicDevlinkComponent = dynamic(()=>import("./dynamic-devlink-component"));
import DynamicDevlinkConfig from "./dynamic-devlink-config";
import DynamicDevlinkAdvancedConfig from "./dynamic-devlink-advanced-config";
import DynamicDevlinkDefaultProps from "./default-props";
// Attach defaultProps to the dynamic component so it can be accessed by the template generator
DynamicDevlinkComponent.defaultProps = DynamicDevlinkDefaultProps;
export default {
    DynamicDevlinkComponent,
    DynamicDevlinkConfig,
    DynamicDevlinkAdvancedConfig
};
